module.exports = __webpack_public_path__ + "img/The State of Disconnected Care in Malaysia.cf42366f.jpg";